import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { PenLine, Sparkles } from "lucide-react";

export default function Navbar() {
    const navigate = useNavigate();
    return (
        <header
            data-testid="site-navbar"
            className="sticky top-0 z-40 bg-[#FAFAFA]/90 backdrop-blur-md border-b-2 border-black"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-4 flex items-center justify-between gap-4">
                <Link
                    to="/"
                    data-testid="nav-logo-link"
                    className="flex items-center gap-3 group"
                >
                    <div className="w-11 h-11 rounded-xl nb-border nb-shadow-sm bg-[#FDE047] flex items-center justify-center group-hover:rotate-[-6deg] transition-transform">
                        <PenLine strokeWidth={3} className="w-5 h-5" />
                    </div>
                    <div>
                        <div className="font-display text-2xl font-black tracking-tight leading-none">
                            Free AI Writers
                        </div>
                        <div className="text-[10px] uppercase tracking-widest font-bold text-neutral-600">
                            Free AI Tools
                        </div>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-6 text-sm font-bold uppercase tracking-wider">
                    <button
                        data-testid="nav-categories-btn"
                        onClick={() => {
                            const el = document.getElementById("categories");
                            if (el) el.scrollIntoView({ behavior: "smooth" });
                            else navigate("/#categories");
                        }}
                        className="hover:underline underline-offset-4 decoration-2"
                    >
                        Categories
                    </button>
                    <button
                        data-testid="nav-tools-btn"
                        onClick={() => {
                            const el = document.getElementById("tools");
                            if (el) el.scrollIntoView({ behavior: "smooth" });
                            else navigate("/#tools");
                        }}
                        className="hover:underline underline-offset-4 decoration-2"
                    >
                        All tools
                    </button>
                </nav>

                <Link
                    to="/tool/chatgpt-alternative"
                    data-testid="nav-try-ai-btn"
                    className="inline-flex items-center gap-2 bg-black text-white px-4 py-2.5 rounded-xl font-bold text-sm nb-border nb-shadow-sm hover:-translate-y-[2px] hover:shadow-[4px_4px_0px_#0A0A0A] active:translate-y-[2px] active:translate-x-[2px] active:shadow-none transition-all"
                >
                    <Sparkles strokeWidth={2.5} className="w-4 h-4" />
                    Ask AI
                </Link>
            </div>
        </header>
    );
}
